
import './content.css'


const Content = (props) => {
    return (
        <div className="content">
            <div className="leftSidebar">
                {props.left}
            </div>
            <div className="center">
                {props.center}
            </div>
            <div className="rightSidebar">
                {props.right}
            </div>
        </div>

    )
}

export default Content